module.exports = __webpack_public_path__ + "img/JF-DH.d9f6ff8e.png";